// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =============================================
=         Design System Color Palette         =
============================================= */
.styles_color__c2KRt.styles_ocean-50__AjkLv {
  color: #e6f2ff;
}

.styles_color__c2KRt.styles_ocean-100__W3bbD {
  color: #e6f2ff;
}

.styles_color__c2KRt.styles_ocean-200__2hMHv {
  color: #b3daff;
}

.styles_color__c2KRt.styles_ocean-300__FfjZA {
  color: #7abfff;
}

.styles_color__c2KRt.styles_ocean-400__vJid2 {
  color: #2392fb;
}

.styles_color__c2KRt.styles_ocean-500__rMElD {
  color: #0074e0;
}

.styles_color__c2KRt.styles_ocean-600__4be4l {
  color: #043571;
}

.styles_color__c2KRt.styles_space-50__wkT2A {
  color: #f0f0f0;
}

.styles_color__c2KRt.styles_space-100__DFJCf {
  color: #e3e3e3;
}

.styles_color__c2KRt.styles_space-200__GAQbD {
  color: #bfbfbf;
}

.styles_color__c2KRt.styles_space-300__AJvmv {
  color: gray;
}

.styles_color__c2KRt.styles_space-400__8MyN1 {
  color: #616161;
}

.styles_color__c2KRt.styles_space-500__xbyuI {
  color: #283439;
}

.styles_color__c2KRt.styles_gray-50__XqSWo {
  color: #eff3f6;
}

.styles_color__c2KRt.styles_gray-100__YUI2k {
  color: #e6ecef;
}

.styles_color__c2KRt.styles_gray-200__jnKHq {
  color: #cfd8de;
}

.styles_color__c2KRt.styles_gray-300__QkYvo {
  color: #a8b9c2;
}

.styles_color__c2KRt.styles_gray-400__OV0Mk {
  color: #7e98a5;
}

.styles_color__c2KRt.styles_gray-500__2ZeUC {
  color: #738f9c;
}

.styles_color__c2KRt.styles_green-50__zIaPJ {
  color: #e3fdf6;
}

.styles_color__c2KRt.styles_green-100__k6SzM {
  color: #c5f6ea;
}

.styles_color__c2KRt.styles_green-200__x0FSZ {
  color: #69ddc2;
}

.styles_color__c2KRt.styles_green-300__dc3kt {
  color: #45bfa3;
}

.styles_color__c2KRt.styles_green-400__tKtrs {
  color: #1cab8a;
}

.styles_color__c2KRt.styles_green-500__TFv79 {
  color: #128268;
}

.styles_color__c2KRt.styles_red-50__HvwbN {
  color: #fff0f3;
}

.styles_color__c2KRt.styles_red-100__9KNlT {
  color: #f9d2db;
}

.styles_color__c2KRt.styles_red-200__VxE6v {
  color: #f8b4c4;
}

.styles_color__c2KRt.styles_red-300__3QwJ4 {
  color: #e85e81;
}

.styles_color__c2KRt.styles_red-400__4gvIf {
  color: #e23661;
}

.styles_color__c2KRt.styles_red-500__4fuF8 {
  color: #b82348;
}

.styles_color__c2KRt.styles_yellow-50__R5qmM {
  color: #fffae6;
}

.styles_color__c2KRt.styles_yellow-100__VUEoL {
  color: #fff0b3;
}

.styles_color__c2KRt.styles_yellow-200__DTPUi {
  color: #ffe380;
}

.styles_color__c2KRt.styles_yellow-300__GormT {
  color: #ffcf57;
}

.styles_color__c2KRt.styles_yellow-400__6jLqW {
  color: #ffc60a;
}

.styles_color__c2KRt.styles_yellow-500__KBgpS {
  color: #ffb700;
}

.styles_color__c2KRt.styles_orange-50__B92si {
  color: #fff2eb;
}

.styles_color__c2KRt.styles_orange-100__lYSLQ {
  color: #ffe4d6;
}

.styles_color__c2KRt.styles_orange-200__L9MDk {
  color: #ffc69e;
}

.styles_color__c2KRt.styles_orange-300__A0z89 {
  color: #ffa047;
}

.styles_color__c2KRt.styles_orange-400__cOCmX {
  color: #ff7b42;
}

.styles_color__c2KRt.styles_orange-500__OrlLM {
  color: #ee4920;
}

.styles_color__c2KRt.styles_turquoise-50__4MHoi {
  color: transparent;
}

.styles_color__c2KRt.styles_turquoise-100__-uWzw {
  color: #e6fcff;
}

.styles_color__c2KRt.styles_turquoise-200__YMUqE {
  color: #b3f5ff;
}

.styles_color__c2KRt.styles_turquoise-300__jf8Ys {
  color: #78e2f2;
}

.styles_color__c2KRt.styles_turquoise-400__ZotZ6 {
  color: #00c7e6;
}

.styles_color__c2KRt.styles_turquoise-500__NzrK5 {
  color: transparent;
}

.styles_color__c2KRt.styles_turquoise-600__bN\\+JP {
  color: transparent;
}

.styles_color__c2KRt.styles_violet-50__h-cDG {
  color: #eae6ff;
}

.styles_color__c2KRt.styles_violet-100__n2i5A {
  color: #d9d1ff;
}

.styles_color__c2KRt.styles_violet-200__lBKYW {
  color: #bfb3ff;
}

.styles_color__c2KRt.styles_violet-300__o\\+fQM {
  color: #9d90ea;
}

.styles_color__c2KRt.styles_violet-400__PjBMi {
  color: #8678d9;
}

.styles_color__c2KRt.styles_violet-500__pKn9- {
  color: #6f5ccc;
}

.styles_color__c2KRt.styles_snow-50__bT7Wk {
  color: white;
}

.styles_color__c2KRt.styles_snow-100__C2RyZ {
  color: #f7f7f7;
}

.styles_color__c2KRt.styles_snow-200__tLGvX {
  color: #f0efef;
}

.styles_color__c2KRt.styles_snow-300__Yml4o {
  color: #e6e6e6;
}

.styles_color__c2KRt.styles_snow-400__3n97O {
  color: #e1e0e0;
}

.styles_color__c2KRt.styles_snow-500__LAu2Z {
  color: #cfcfcf;
}

/* =============================================
=              Background Colors              =
============================================= */
.styles_background-color__SQ-yE.styles_ocean__3dZj5 {
  background-color: #2392fb;
  color: white;
}

.styles_background-color__SQ-yE.styles_ocean-light__S4LxY {
  background-color: #b3daff;
  color: white;
}

.styles_background-color__SQ-yE.styles_green__i6T9r {
  background-color: #1cab8a;
  color: white;
}

.styles_background-color__SQ-yE.styles_green-light__Rxf6K {
  background-color: #69ddc2;
  color: white;
}

.styles_background-color__SQ-yE.styles_red__B2CyJ {
  background-color: #e23661;
  color: white;
}

.styles_background-color__SQ-yE.styles_red-light__OUkN2 {
  background-color: #f8b4c4;
  color: white;
}

.styles_background-color__SQ-yE.styles_orange__LH\\+C- {
  background-color: #ff7b42;
  color: white;
}

.styles_background-color__SQ-yE.styles_orange-light__8iZT0 {
  background-color: #ffc69e;
  color: white;
}

.styles_background-color__SQ-yE.styles_space__c1b41 {
  background-color: #616161;
  color: white;
}

.styles_background-color__SQ-yE.styles_space-light__URvnr {
  background-color: #bfbfbf;
  color: #616161;
}

.styles_background-color__SQ-yE.styles_gray-light__Yl5B8 {
  background-color: #f0efef;
  color: #616161;
}

.styles_background-color__SQ-yE.styles_violet__YeAGF {
  background-color: #8678d9;
  color: white;
}

.styles_background-color__SQ-yE.styles_violet-light__flR0w {
  background-color: #bfb3ff;
  color: #616161;
}

.styles_background-color__SQ-yE.styles_yellow__Ro4yS {
  background-color: #ffc60a;
  color: white;
}

.styles_background-color__SQ-yE.styles_yellow-light__XSB8F {
  background-color: #ffe380;
  color: #616161;
}

/* The "blur" parameter (the third one) for drop shadow is rendered twice as in the box shadow.
 * So we have to divide it by 2 to have the same output as box shadows.
*/
.styles_root__WUDGt {
  --divider-thickness: 2px;
  background-color: #e6ecef;
}
.styles_root__WUDGt.styles_narrow__KYmJf {
  --divider-thickness: 1px;
}
.styles_root__WUDGt.styles_thick__bZ7vo {
  --divider-thickness: 4px;
}
.styles_root__WUDGt.styles_vertical__YFriv {
  height: 100%;
  margin: 0px 8px ;
  width: var(--divider-thickness);
}
.styles_root__WUDGt:not(.styles_vertical__YFriv) {
  height: var(--divider-thickness);
  margin: 8px 0px ;
  width: 100%;
}
.styles_root__WUDGt:not(.styles_vertical__YFriv).styles_loose__Q\\+ca0 {
  margin: 16px 0px ;
}
.styles_root__WUDGt:not(.styles_vertical__YFriv).styles_dense__uXLpa {
  margin-top: 4px ;
}
.styles_root__WUDGt:not(.styles_vertical__YFriv).styles_noMargin__lqqtp {
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/ui-kit/styles/_theme/_colors.scss","webpack://./src/ui-kit/components/divider/styles.module.scss","webpack://./src/ui-kit/styles/_theme/_shadows.scss"],"names":[],"mappings":"AAEA;;+CAAA;AAmFI;EACI,cAjFC;ACAT;;ADgFI;EACI,cAjFC;ACIT;;AD4EI;EACI,cAjFC;ACQT;;ADwEI;EACI,cAjFC;ACYT;;ADoEI;EACI,cAjFC;ACgBT;;ADgEI;EACI,cAjFC;ACoBT;;AD4DI;EACI,cAjFC;ACwBT;;ADwDI;EACI,cAjFC;AC4BT;;ADoDI;EACI,cAjFC;ACgCT;;ADgDI;EACI,cAjFC;ACoCT;;AD4CI;EACI,WAjFC;ACwCT;;ADwCI;EACI,cAjFC;AC4CT;;ADoCI;EACI,cAjFC;ACgDT;;ADgCI;EACI,cAjFC;ACoDT;;AD4BI;EACI,cAjFC;ACwDT;;ADwBI;EACI,cAjFC;AC4DT;;ADoBI;EACI,cAjFC;ACgET;;ADgBI;EACI,cAjFC;ACoET;;ADYI;EACI,cAjFC;ACwET;;ADQI;EACI,cAjFC;AC4ET;;ADII;EACI,cAjFC;ACgFT;;ADAI;EACI,cAjFC;ACoFT;;ADJI;EACI,cAjFC;ACwFT;;ADRI;EACI,cAjFC;AC4FT;;ADZI;EACI,cAjFC;ACgGT;;ADhBI;EACI,cAjFC;ACoGT;;ADpBI;EACI,cAjFC;ACwGT;;ADxBI;EACI,cAjFC;AC4GT;;AD5BI;EACI,cAjFC;ACgHT;;ADhCI;EACI,cAjFC;ACoHT;;ADpCI;EACI,cAjFC;ACwHT;;ADxCI;EACI,cAjFC;AC4HT;;AD5CI;EACI,cAjFC;ACgIT;;ADhDI;EACI,cAjFC;ACoIT;;ADpDI;EACI,cAjFC;ACwIT;;ADxDI;EACI,cAjFC;AC4IT;;AD5DI;EACI,cAjFC;ACgJT;;ADhEI;EACI,cAjFC;ACoJT;;ADpEI;EACI,cAjFC;ACwJT;;ADxEI;EACI,cAjFC;AC4JT;;AD5EI;EACI,cAjFC;ACgKT;;ADhFI;EACI,cAjFC;ACoKT;;ADpFI;EACI,cAjFC;ACwKT;;ADxFI;EACI,kBAjFC;AC4KT;;AD5FI;EACI,cAjFC;ACgLT;;ADhGI;EACI,cAjFC;ACoLT;;ADpGI;EACI,cAjFC;ACwLT;;ADxGI;EACI,cAjFC;AC4LT;;AD5GI;EACI,kBAjFC;ACgMT;;ADhHI;EACI,kBAjFC;ACoMT;;ADpHI;EACI,cAjFC;ACwMT;;ADxHI;EACI,cAjFC;AC4MT;;AD5HI;EACI,cAjFC;ACgNT;;ADhII;EACI,cAjFC;ACoNT;;ADpII;EACI,cAjFC;ACwNT;;ADxII;EACI,cAjFC;AC4NT;;AD5II;EACI,YAjFC;ACgOT;;ADhJI;EACI,cAjFC;ACoOT;;ADpJI;EACI,cAjFC;ACwOT;;ADxJI;EACI,cAjFC;AC4OT;;AD5JI;EACI,cAjFC;ACgPT;;ADhKI;EACI,cAjFC;ACoPT;;AD/JA;;+CAAA;AA8EI;EALA,yBAAA;EACA,YAAA;AC6FJ;;ADzFI;EALA,yBAAA;EACA,YAAA;ACkGJ;;AD9FI;EALA,yBAAA;EACA,YAAA;ACuGJ;;ADnGI;EALA,yBAAA;EACA,YAAA;AC4GJ;;ADxGI;EALA,yBAAA;EACA,YAAA;ACiHJ;;AD7GI;EALA,yBAAA;EACA,YAAA;ACsHJ;;ADlHI;EALA,yBAAA;EACA,YAAA;AC2HJ;;ADvHI;EALA,yBAAA;EACA,YAAA;ACgIJ;;AD5HI;EALA,yBAAA;EACA,YAAA;ACqIJ;;ADjII;EALA,yBAAA;EACA,cAAA;AC0IJ;;ADtII;EALA,yBAAA;EACA,cAAA;AC+IJ;;AD3II;EALA,yBAAA;EACA,YAAA;ACoJJ;;ADhJI;EALA,yBAAA;EACA,cAAA;ACyJJ;;ADrJI;EALA,yBAAA;EACA,YAAA;AC8JJ;;AD1JI;EALA,yBAAA;EACA,cAAA;ACmKJ;;ACtTA;;CAAA;ADdA;EACI,wBAAA;EAEA,yBAAA;AAyUJ;AAvUI;EACI,wBAAA;AAyUR;AAtUI;EACI,wBAAA;AAwUR;AArUI;EACI,YAAA;EACA,gBAAA;EACA,+BAAA;AAuUR;AApUI;EACI,gCAAA;EACA,gBAAA;EACA,WAAA;AAsUR;AApUQ;EACI,iBAAA;AAsUZ;AAnUQ;EACI,gBAAA;AAqUZ;AAlUQ;EACI,SAAA;AAoUZ","sourcesContent":["@use 'sass:map';\n\n/* =============================================\n=         Design System Color Palette         =\n============================================= */\n$colors: (\n    // ocean\n    ocean-50: hsla(210, 100%, 95%, 1),\n    ocean-100: hsla(210, 100%, 95%, 1),\n    ocean-200: hsla(209, 100%, 85%, 1),\n    ocean-300: hsla(209, 100%, 74%, 1),\n    ocean-400: hsla(209, 96%, 56%, 1),\n    ocean-500: hsla(209, 100%, 44%, 1),\n    ocean-600: hsla(213, 93%, 23%, 1),\n    // space\n    space-50: hsla(0, 0%, 94%, 1),\n    space-100: hsla(0, 0%, 89%, 1),\n    space-200: hsla(0, 0%, 75%, 1),\n    space-300: hsla(0, 0%, 50%, 1),\n    space-400: hsla(0, 0%, 38%, 1),\n    space-500: hsla(198, 18%, 19%, 1),\n    // gray\n    gray-50: hsla(200, 27%, 95%, 1),\n    gray-100: hsla(200, 21%, 92%, 1),\n    gray-200: hsla(201, 18%, 84%, 1),\n    gray-300: hsla(201, 18%, 71%, 1),\n    gray-400: hsla(200, 18%, 57%, 1),\n    gray-500: hsl(199, 17%, 53%, 1),\n    // green\n    green-50: hsla(164, 85%, 94%, 1),\n    green-100: hsla(165, 74%, 87%, 1),\n    green-200: hsla(166, 63%, 64%, 1),\n    green-300: hsla(166, 49%, 51%, 1),\n    green-400: hsla(166, 72%, 39%, 1),\n    green-500: hsla(166, 76%, 29%, 1),\n    // red\n    red-50: hsla(346, 100%, 97%, 1),\n    red-100: hsla(346, 76%, 90%, 1),\n    red-200: hsla(346, 83%, 84%, 1),\n    red-300: hsla(345, 75%, 64%, 1),\n    red-400: hsla(345, 75%, 55%, 1),\n    red-500: hsla(345, 68%, 43%, 1),\n    // yellow\n    yellow-50: hsla(48, 100%, 95%, 1),\n    yellow-100: hsla(48, 100%, 85%, 1),\n    yellow-200: hsla(47, 100%, 75%, 1),\n    yellow-300: hsla(43, 100%, 67%, 1),\n    yellow-400: hsla(46, 100%, 52%, 1),\n    yellow-500: hsla(43, 100%, 50%, 1),\n    // orange\n    orange-50: hsla(21, 100%, 96%, 1),\n    orange-100: hsla(21, 100%, 92%, 1),\n    orange-200: hsla(25, 100%, 81%, 1),\n    orange-300: hsla(29, 100%, 64%, 1),\n    orange-400: hsla(18, 100%, 63%, 1),\n    orange-500: hsla(12, 86%, 53%, 1),\n    // turquoise\n    turquoise-50: transparent, // TODO: update this value when it got defined on the designs\n    turquoise-100: hsla(187, 100%, 95%, 1),\n    turquoise-200: hsla(188, 100%, 85%, 1),\n    turquoise-300: hsla(188, 82%, 71%, 1),\n    turquoise-400: hsla(188, 100%, 45%, 1),\n    turquoise-500: transparent, // TODO: update this value when it got defined on the designs\n    turquoise-600: transparent, // TODO: update this value when it got defined on the designs\n    // violet\n    violet-50: hsla(250, 100%, 95%, 1),\n    violet-100: hsla(250, 100%, 91%, 1),\n    violet-200: hsla(250, 100%, 85%, 1),\n    violet-300: hsla(249, 68%, 74%, 1),\n    violet-400: hsla(249, 56%, 66%, 1),\n    violet-500: hsla(250, 52%, 58%, 1),\n    // snow\n    snow-50: hsla(0, 0%, 100%, 1),\n    snow-100: hsla(0, 0%, 97%, 1),\n    snow-200: hsla(0, 3%, 94%, 1),\n    snow-300: hsla(0, 0%, 90%, 1),\n    snow-400: hsla(0, 1%, 88%, 1),\n    snow-500: hsla(0, 0%, 81%, 1),\n);\n\n@function color($color) {\n    @return map.get($colors, $color);\n}\n\n@each $name, $color in $colors {\n    .color.#{$name} {\n        color: $color;\n    }\n}\n\n/* =============================================\n=              Background Colors              =\n============================================= */\n$background-colors: (\n    ocean: (\n        color: color(ocean-400),\n        contrast-color: color(snow-50),\n    ),\n    ocean-light: (\n        color: color(ocean-200),\n        contrast-color: color(snow-50),\n    ),\n    'green': (\n        color: color(green-400),\n        contrast-color: color(snow-50),\n    ),\n    green-light: (\n        color: color(green-200),\n        contrast-color: color(snow-50),\n    ),\n    'red': (\n        color: color(red-400),\n        contrast-color: color(snow-50),\n    ),\n    red-light: (\n        color: color(red-200),\n        contrast-color: color(snow-50),\n    ),\n    'orange': (\n        color: color(orange-400),\n        contrast-color: color(snow-50),\n    ),\n    orange-light: (\n        color: color(orange-200),\n        contrast-color: color(snow-50),\n    ),\n    space: (\n        color: color(space-400),\n        contrast-color: color(snow-50),\n    ),\n    space-light: (\n        color: color(space-200),\n        contrast-color: color(space-400),\n    ),\n    gray-light: (\n        color: color(snow-200),\n        contrast-color: color(space-400),\n    ),\n    'violet': (\n        color: color(violet-400),\n        contrast-color: color(snow-50),\n    ),\n    violet-light: (\n        color: color(violet-200),\n        contrast-color: color(space-400),\n    ),\n    'yellow': (\n        color: color(yellow-400),\n        contrast-color: color(snow-50),\n    ),\n    yellow-light: (\n        color: color(yellow-200),\n        contrast-color: color(space-400),\n    ),\n);\n\n@function get-background-color($color-name) {\n    @return map.get($background-colors, $color-name);\n}\n\n@mixin background-color($name) {\n    $colors: get-background-color($name);\n\n    background-color: map.get($colors, color);\n    color: map.get($colors, contrast-color);\n}\n\n@each $name in map-keys($background-colors) {\n    .background-color.#{$name} {\n        @include background-color($name);\n    }\n}\n","@use 'sass:color';\n@use '~$app-web/ui-kit/styles/theme';\n\n.root {\n    --divider-thickness: 2px;\n\n    background-color: theme.color(gray-100);\n\n    &.narrow {\n        --divider-thickness: 1px;\n    }\n\n    &.thick {\n        --divider-thickness: 4px;\n    }\n\n    &.vertical {\n        height: 100%;\n        margin: theme.spacing(0, 1);\n        width: var(--divider-thickness);\n    }\n\n    &:not(.vertical) {\n        height: var(--divider-thickness);\n        margin: theme.spacing(1, 0);\n        width: 100%;\n\n        &.loose {\n            margin: theme.spacing(2, 0);\n        }\n\n        &.dense {\n            margin-top: theme.spacing(0.5);\n        }\n\n        &.noMargin {\n            margin: 0;\n        }\n    }\n}\n","@use 'sass:map';\n@use 'sass:string';\n\n$shadow-base-color: rgb(9, 30, 66);\n$second-shadow-color: rgba($shadow-base-color, 0.31);\n\n// TODO-MAYBE: Use our design system color palette colors.\n$box-shadows: (\n    sm: (0 1px 1px rgba($shadow-base-color, 0.25), 0 0 1px $second-shadow-color),\n    md: (0 3px 5px rgba($shadow-base-color, 0.2), 0 0 1px $second-shadow-color),\n    lg: (0 8px 12px rgba($shadow-base-color, 0.15), 0 0 1px $second-shadow-color),\n    xl: (0 18px 28px rgba($shadow-base-color, 0.15), 0 0 1px $second-shadow-color),\n    // TODO: These are not correct. They should be fixed when the values are fixed in Figma.\n    right: 0 0 20px rgba(73, 73, 73, 0.3),\n    left: 0 0 20px rgba(73, 73, 73, 0.3),\n);\n\n/* The \"blur\" parameter (the third one) for drop shadow is rendered twice as in the box shadow.\n * So we have to divide it by 2 to have the same output as box shadows.\n*/\n$drop-shadows: (\n    sm: (drop-shadow(0 1px 0.5px rgba($shadow-base-color, 0.25)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    md: (drop-shadow(0 3px 2.5px rgba($shadow-base-color, 0.2)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    lg: (drop-shadow(0 8px 6px rgba($shadow-base-color, 0.15)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    xl: (drop-shadow(0 18px 14px rgba($shadow-base-color, 0.15)) drop-shadow(0 0 0.5px $second-shadow-color)),\n);\n\n@function box-shadow($shadow: sm) {\n    @return map.get($box-shadows, $shadow);\n}\n\n@function drop-shadow($shadow: sm) {\n    @return map.get($drop-shadows, $shadow);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color": `styles_color__c2KRt`,
	"ocean-50": `styles_ocean-50__AjkLv`,
	"ocean-100": `styles_ocean-100__W3bbD`,
	"ocean-200": `styles_ocean-200__2hMHv`,
	"ocean-300": `styles_ocean-300__FfjZA`,
	"ocean-400": `styles_ocean-400__vJid2`,
	"ocean-500": `styles_ocean-500__rMElD`,
	"ocean-600": `styles_ocean-600__4be4l`,
	"space-50": `styles_space-50__wkT2A`,
	"space-100": `styles_space-100__DFJCf`,
	"space-200": `styles_space-200__GAQbD`,
	"space-300": `styles_space-300__AJvmv`,
	"space-400": `styles_space-400__8MyN1`,
	"space-500": `styles_space-500__xbyuI`,
	"gray-50": `styles_gray-50__XqSWo`,
	"gray-100": `styles_gray-100__YUI2k`,
	"gray-200": `styles_gray-200__jnKHq`,
	"gray-300": `styles_gray-300__QkYvo`,
	"gray-400": `styles_gray-400__OV0Mk`,
	"gray-500": `styles_gray-500__2ZeUC`,
	"green-50": `styles_green-50__zIaPJ`,
	"green-100": `styles_green-100__k6SzM`,
	"green-200": `styles_green-200__x0FSZ`,
	"green-300": `styles_green-300__dc3kt`,
	"green-400": `styles_green-400__tKtrs`,
	"green-500": `styles_green-500__TFv79`,
	"red-50": `styles_red-50__HvwbN`,
	"red-100": `styles_red-100__9KNlT`,
	"red-200": `styles_red-200__VxE6v`,
	"red-300": `styles_red-300__3QwJ4`,
	"red-400": `styles_red-400__4gvIf`,
	"red-500": `styles_red-500__4fuF8`,
	"yellow-50": `styles_yellow-50__R5qmM`,
	"yellow-100": `styles_yellow-100__VUEoL`,
	"yellow-200": `styles_yellow-200__DTPUi`,
	"yellow-300": `styles_yellow-300__GormT`,
	"yellow-400": `styles_yellow-400__6jLqW`,
	"yellow-500": `styles_yellow-500__KBgpS`,
	"orange-50": `styles_orange-50__B92si`,
	"orange-100": `styles_orange-100__lYSLQ`,
	"orange-200": `styles_orange-200__L9MDk`,
	"orange-300": `styles_orange-300__A0z89`,
	"orange-400": `styles_orange-400__cOCmX`,
	"orange-500": `styles_orange-500__OrlLM`,
	"turquoise-50": `styles_turquoise-50__4MHoi`,
	"turquoise-100": `styles_turquoise-100__-uWzw`,
	"turquoise-200": `styles_turquoise-200__YMUqE`,
	"turquoise-300": `styles_turquoise-300__jf8Ys`,
	"turquoise-400": `styles_turquoise-400__ZotZ6`,
	"turquoise-500": `styles_turquoise-500__NzrK5`,
	"turquoise-600": `styles_turquoise-600__bN+JP`,
	"violet-50": `styles_violet-50__h-cDG`,
	"violet-100": `styles_violet-100__n2i5A`,
	"violet-200": `styles_violet-200__lBKYW`,
	"violet-300": `styles_violet-300__o+fQM`,
	"violet-400": `styles_violet-400__PjBMi`,
	"violet-500": `styles_violet-500__pKn9-`,
	"snow-50": `styles_snow-50__bT7Wk`,
	"snow-100": `styles_snow-100__C2RyZ`,
	"snow-200": `styles_snow-200__tLGvX`,
	"snow-300": `styles_snow-300__Yml4o`,
	"snow-400": `styles_snow-400__3n97O`,
	"snow-500": `styles_snow-500__LAu2Z`,
	"background-color": `styles_background-color__SQ-yE`,
	"ocean": `styles_ocean__3dZj5`,
	"ocean-light": `styles_ocean-light__S4LxY`,
	"green": `styles_green__i6T9r`,
	"green-light": `styles_green-light__Rxf6K`,
	"red": `styles_red__B2CyJ`,
	"red-light": `styles_red-light__OUkN2`,
	"orange": `styles_orange__LH+C-`,
	"orange-light": `styles_orange-light__8iZT0`,
	"space": `styles_space__c1b41`,
	"space-light": `styles_space-light__URvnr`,
	"gray-light": `styles_gray-light__Yl5B8`,
	"violet": `styles_violet__YeAGF`,
	"violet-light": `styles_violet-light__flR0w`,
	"yellow": `styles_yellow__Ro4yS`,
	"yellow-light": `styles_yellow-light__XSB8F`,
	"root": `styles_root__WUDGt`,
	"narrow": `styles_narrow__KYmJf`,
	"thick": `styles_thick__bZ7vo`,
	"vertical": `styles_vertical__YFriv`,
	"loose": `styles_loose__Q+ca0`,
	"dense": `styles_dense__uXLpa`,
	"noMargin": `styles_noMargin__lqqtp`
};
export default ___CSS_LOADER_EXPORT___;
